// src/views/MergeAudioVideo.js
import React, { useState } from 'react';
import { Video, Music, Repeat, RotateCcw } from 'lucide-react';
import { useAudioEngine } from '../hooks/useAudioEngine';

const MergeAudioVideo = ({ setIsExporting, setExportProgress }) => {
  const [videoFile, setVideoFile] = useState(null);
  const [audioFile, setAudioFile] = useState(null);
  const { mergeAudioVideo } = useAudioEngine(null, null);

  const handleMerge = () => {
    mergeAudioVideo(videoFile, audioFile, setIsExporting, setExportProgress);
  };

  return (
    <div className="max-w-lg mx-auto text-center space-y-10 animate-in fade-in">
      <div className="space-y-4">
        <h2 className="text-4xl font-black uppercase tracking-tighter">Merge Audio & Video</h2>
        <p className="text-slate-400">Replace the sound of any video with a custom audio file.</p>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {/* Upload Video Box */}
        <div className={`p-10 border-2 border-dashed rounded-[32px] transition-all relative group ${videoFile ? 'bg-amber-500/10 border-amber-500/50' : 'bg-slate-900/30 border-slate-800 hover:border-amber-500'}`}>
          <Video className={`mx-auto mb-4 ${videoFile ? 'text-amber-500' : 'text-slate-700'}`} size={32} />
          <input type="file" accept="video/*" className="absolute inset-0 opacity-0 cursor-pointer" onChange={(e) => setVideoFile(e.target.files[0])} />
          <p className="text-xs font-black uppercase">{videoFile ? videoFile.name : 'Select Video'}</p>
        </div>

        {/* Upload Audio Box */}
        <div className={`p-10 border-2 border-dashed rounded-[32px] transition-all relative group ${audioFile ? 'bg-amber-500/10 border-amber-500/50' : 'bg-slate-900/30 border-slate-800 hover:border-amber-500'}`}>
          <Music className={`mx-auto mb-4 ${audioFile ? 'text-amber-500' : 'text-slate-700'}`} size={32} />
          <input type="file" accept="audio/*" className="absolute inset-0 opacity-0 cursor-pointer" onChange={(e) => setAudioFile(e.target.files[0])} />
          <p className="text-xs font-black uppercase">{audioFile ? audioFile.name : 'Select Audio'}</p>
        </div>
      </div>

      {videoFile && audioFile && (
        <button 
          onClick={handleMerge}
          className="w-full bg-amber-500 text-black py-5 rounded-3xl font-black flex items-center justify-center gap-3 shadow-lg hover:scale-[1.02] transition-all"
        >
          <Repeat size={20} /> MERGE FILES
        </button>
      )}

      {(videoFile || audioFile) && (
        <button onClick={() => { setVideoFile(null); setAudioFile(null); }} className="flex items-center gap-2 mx-auto text-slate-500 uppercase text-xs font-black hover:text-white transition-colors">
          <RotateCcw size={14} /> Clear All
        </button>
      )}
    </div>
  );
};

export default MergeAudioVideo;